import Service from './service';

export default class AuthService extends Service {
  baseApi = '/auth';

  async login(data) {
    const url = `${this.baseApi}/login`;
    return await this.postResource(url, data);
  }

  async logout(data) {
    const url = `${this.baseApi}/logout`;
    return await this.postResource(url, data);
  }

  async updatePassword(data) {
    const url = `${this.baseApi}/update-password`;
    return await this.postResource(url, data);
  }

  async updatePasswordByAdmin(data) {
    const url = `${this.baseApi}/update-password-byadmin`;
    return await this.postResource(url, data);
  }

  async sendEmail(data) {
    const url = `${this.baseApi}/mail`;
    return await this.postResource(url, data);
  }

  async checkToken(data) {
    const url = `${this.baseApi}/token`;
    return await this.postResource(url, data);
  }

  async recoveryPassword(data) {
    const url = `${this.baseApi}/recovery-password`;
    return await this.postResource(url, data);
  }
}
